import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import styled from 'styled-components';
import { useDevicePresence } from '../utils/media';
import { Button } from './Button';
import { CircularVolumeIndicator } from './CircularVolumeIndicator';
import { CameraIcon, CaretIcon, LargeExclamationMarkIcon, MicrophoneIcon, } from './Icon';
import { showNoCameraFoundPopup, showNoMicrophoneFoundPopup, } from './popups/DeviceErrorPopup';
import { selectDevice } from './popups/DevicePopup';
function DeviceButton({ kind, muted: mutedProp, onMuteClick, children, }) {
    const buttonRef = useRef(null);
    const { [kind]: devicePresent } = useDevicePresence();
    const muted = !devicePresent || mutedProp;
    return (_jsxs(DoubleButtonWrap, { children: [_jsx(UnderneathButton, { disabled: !devicePresent, type: "button", ref: buttonRef, onClick: () => {
                    selectDevice(kind, {
                        anchorRef: buttonRef,
                    });
                }, children: _jsx(CaretIcon, {}) }), _jsxs(TopButton, { type: "button", kind: muted ? undefined : 'secondary', variant: muted ? undefined : 'dark', shape: "pill", padding: "none", onClick: () => {
                    if (devicePresent) {
                        onMuteClick();
                    }
                    else {
                        if (kind === 'audio') {
                            showNoMicrophoneFoundPopup();
                        }
                        else {
                            showNoCameraFoundPopup();
                        }
                    }
                }, children: [children, !devicePresent && (_jsx(NoDeviceIconWrap, { title: `No ${kind === 'audio' ? 'microphone' : 'camera'} found`, children: _jsx(LargeExclamationMarkIcon, {}) }))] })] }));
}
export function AudioDeviceButton({ muted, onMuteClick, volumeControllerRef, }) {
    const { audio: microphonePresent } = useDevicePresence();
    return (_jsxs(DeviceButton, { muted: muted, onMuteClick: onMuteClick, kind: "audio", children: [_jsx(MicrophoneIcon, { muted: !microphonePresent || muted }), microphonePresent && !muted && (_jsx(CircularVolumeIndicator, { volumeControllerRef: volumeControllerRef }))] }));
}
export function VideoDeviceButton({ muted, onMuteClick }) {
    const { video: cameraPresent } = useDevicePresence();
    return (_jsx(DeviceButton, { kind: "video", muted: muted, onMuteClick: onMuteClick, children: _jsx(CameraIcon, { muted: !cameraPresent || muted }) }));
}
const NoDeviceIconWrap = styled.div `
    position: absolute;
    right: 0;
    top: 0;

    svg {
        position: relative;
        z-index: 1;
    }

    &::before {
        background-color: #ffffff;
        border-radius: 50%;
        content: '';
        height: 75%;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 75%;
    }
`;
const TopButton = styled(Button) ``;
const UnderneathButton = styled.button `
    appearance: none;
    width: 100%;
    height: 3.75rem;
    border: 0;
    border-radius: 1.875rem;
    padding: 0;
    padding-left: 1rem;
    background: rgba(255, 255, 255, 0.1);
    align-items: center;

    &:disabled svg {
        opacity: 0.5;
    }
`;
const DoubleButtonWrap = styled.div `
    position: relative;
    width: 3.75rem;

    ${UnderneathButton} {
        display: none;
    }

    @media (min-width: 20rem) {
        width: 6.5rem;

        ${TopButton} {
            position: absolute;
            top: 0;
            right: 0;
        }

        ${UnderneathButton} {
            display: flex;
        }
    }
`;
